import React from 'react';
import {useRef, useEffect, useState} from 'react';
import axios from 'axios';

// import './logoutPageStyle.css';

// User defined Utils
import clearAllCookies from '../utils/cookieManagement';

function LogoutPage() {
    const [data, setData] = useState('');

    useEffect(() => {
        const getCookie = (name) => {
            const match = document.cookie
              .split("; ")
              .find((row) => row.startsWith(name + "="));
          
            if (!match) return null; // Return null if cookie not found
      
            try {
              const rawValue = match.split("=")[1];
            //   console.log(`Raw cookie value for ${name}:`, rawValue);
              return decodeURIComponent(rawValue); // Properly decode it
            } catch (error) {
              console.error(`Error decoding cookie ${name}:`, error);
              return null; // Return null if decoding fails
            }
        }

        const logClientOut = async () => {
            const loginToken = getCookie('data');

            try {
                const isLoggedOut = await axios(
                {
                    url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/auth/logout`, 
                    method: 'POST',
                    /*headers: {
                        // ADDED Security Measure
                        //apiKey: 'qazwsxedcrfvvfrcdexswzaq',
                        // 'Access-Control-Allow-Origin': 'http://localhost:8080/api/auth/login'
                    },*/
                    data: {
                        loginToken: loginToken
                    }
                });
                // If response from backend is 200 then remove the loginToken cookie from client browser and redirect to Homepage
                if(isLoggedOut.status === 200) {
                    clearAllCookies();
                    // document.cookie = `data=; Path=/; Max-Age=-99999999;`;
                    // document.cookie = `username=; Path=/; Max-Age=-99999999;`;
                    // document.cookie = `email=; Path=/; Max-Age=-99999999;`;
                    setTimeout(() => {location.href = '/'}, 1000);
                // If repsonse was not successful then remove loginToken cookie anyway and redirect user to not found page
                } else {
                    clearAllCookies();
                    // document.cookie = `data=; Path=/; Max-Age=-99999999;`;
                    // document.cookie = `username=; Path=/; Max-Age=-99999999;`;
                    // document.cookie = `email=; Path=/; Max-Age=-99999999;`;
                    setTimeout(() => {location.href = '/notfound'}, 500)
                }   
            } catch (err) {
                // NEED TO ADD MORE
                console.log(err);
            }
        }
        logClientOut()
    },[]);

    return(
        <article className='container'>
            <section className=''>
                <h2 className='h1'>You have Successfully Logged Out</h2>
            </section>
        </article>
    );
}

export default LogoutPage;